import { render, staticRenderFns } from "./PageEditProfileName.vue?vue&type=template&id=35fd55f2&scoped=true&"
import script from "./PageEditProfileName.vue?vue&type=script&lang=js&"
export * from "./PageEditProfileName.vue?vue&type=script&lang=js&"
import style0 from "./PageEditProfileName.vue?vue&type=style&index=0&id=35fd55f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd55f2",
  null
  
)

export default component.exports